"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _system = require("@mui/system");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /* eslint-disable no-shadow */ /* eslint-disable consistent-return */
/**
 *
 * @param {*} param0
 */
var Text = function Text(props) {
  var theme = (0, _system.useTheme)();
  var align = props.align,
    bold = props.bold,
    avMedium = props.avMedium,
    veryBold = props.veryBold,
    light = props.light,
    color = props.color,
    customLinkStyle = props.customLinkStyle,
    customStyle = props.customStyle,
    display = props.display,
    isSelected = props.isSelected,
    isSelectedColor = props.isSelectedColor,
    large = props.large,
    link = props.link,
    id = props.id,
    testid = props.testid,
    extraLarge = props.extraLarge,
    largest = props.largest,
    margin = props.margin,
    medium = props.medium,
    mediumLarge = props.mediumLarge,
    onClick = props.onClick,
    small = props.small,
    children = props.children,
    tiny = props.tiny,
    superTiny = props.superTiny,
    uppercase = props.uppercase,
    isDollar = props.isDollar,
    formatted = props.formatted,
    tip = props.tip;

  /**
   * 
   */
  var setFontSize = function setFontSize() {
    if (superTiny) {
      return '10px';
    }
    if (tiny) {
      return '12px';
    }
    if (small) {
      return '14px';
    }
    if (medium) {
      return '16px';
    }
    if (mediumLarge) {
      return '21px';
    }
    if (large) {
      return '24px';
    }
    if (extraLarge) {
      return '28px';
    }
    if (largest) {
      return '40px';
    }
    return '16px';
  };

  /**
   * 
   * @returns 
   */
  var setFontFamily = function setFontFamily() {
    if (light) {
      return '"AvenirLTPro-Light", sans-serif';
    }
    if (avMedium) {
      return '"AvenirLTPro-Medium", sans-serif';
    }
    if (bold || isSelected) {
      return '"AvenirLTPro-Heavy", sans-serif';
    }
    if (veryBold) {
      return '"AvenirLTPro-Heavy", sans-serif';
    }
    return '"AvenirLTPro-Book", sans-serif';
  };

  /**
   * \
   */
  var setColor = function setColor(color) {
    switch (color) {
      case "inherit":
        return "inherit";
      case "primary":
        return theme.palette.primary.main;
      default:
        return color || theme.palette["default"].contrastText;
    }
  };
  if (uppercase) {
    children = children.toUpperCase();
  }
  if (isSelected && isSelectedColor) {
    color = isSelectedColor;
  }
  if (typeof link !== 'string') {
    link = null;
  }
  if (isDollar) {
    children = Number(children).toFixed(2);
  }
  var textBlock = /*#__PURE__*/_react["default"].createElement("p", {
    id: id || testid,
    onClick: onClick && function () {
      return onClick();
    },
    style: _objectSpread({
      fontSize: setFontSize(),
      fontFamily: setFontFamily(),
      fontWeight: veryBold ? 900 : "auto",
      letterSpacing: "0.14994px",
      textAlign: align || 'left',
      color: setColor(color),
      margin: margin || '0px 0px 0px 0px',
      display: display || 'block'
    }, customStyle)
  }, children);

  // if we want to keep the formatting, use a pre tag
  if (formatted) {
    textBlock = /*#__PURE__*/_react["default"].createElement("pre", {
      id: id || testid,
      onClick: onClick && function () {
        return onClick();
      },
      style: _objectSpread({
        fontSize: setFontSize(),
        fontFamily: setFontFamily(),
        fontWeight: veryBold ? 900 : "auto",
        letterSpacing: "0.14994px",
        textAlign: align || 'left',
        color: setColor(color),
        margin: margin || '0px 0px 0px 0px',
        display: display || 'block',
        backgroundColor: 'transparent',
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word',
        overflowWrap: 'anywhere'
      }, customStyle)
    }, children);
  }
  if (tip) {
    textBlock = /*#__PURE__*/_react["default"].createElement("span", {
      id: id || testid,
      onClick: onClick && function () {
        return onClick();
      },
      style: _objectSpread({
        fontSize: setFontSize(),
        fontFamily: setFontFamily(),
        fontWeight: veryBold ? 900 : "auto",
        letterSpacing: "0.14994px",
        textAlign: align || 'left',
        color: setColor(color),
        margin: margin || '0px 0px 0px 0px',
        display: display || 'block'
      }, customStyle)
    }, children);
  }
  if (link) {
    return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
      to: link,
      style: customLinkStyle ? customLinkStyle : {
        textDecoration: 'none'
      }
    }, textBlock);
  }
  return textBlock;
};
var _default = exports["default"] = Text;